import React, { useContext, useState } from "react";
import CurrencyFlag from "react-currency-flags";
import currencies from "../assets/data/currencies";
import NumberFormat from "react-number-format";
import CryptoContext from "../context/crypto/cryptoContext";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { formatNumber } from "../helpers/format";
import Marquee from "react-fast-marquee";
import { withRouter } from "react-router-dom";
const Header = ({ location }) => {
  const {
    setConvt,
    convt,
    headerCoins,
    livePriceData,
    exchangeRate,
    currencySymbol,
  } = useContext(CryptoContext);
  const [close, setClose] = useState(true);

  // const [show, setShow] = useState(true);
  // useEffect(() => {
  //   if (location.pathname.split("/", 3).join("/") === "/mobile/graph") {
  //     setShow(false);
  //   }
  // }, [location]);
  return (
    <>
      <div className="Header">
        <div className="Header__container">
          {/* <div className="Header__links__container"> */}
          <Marquee className="Header_marquee">
            {headerCoins && headerCoins.length > 0 ? (
              headerCoins.map((d, index) => (
              
                  <div className="Header__linkitems" key={index}>
                    {d.id}
                    <span className="Header__linkitems__values">
                      ( Mk Cap:
                      {currencySymbol} {formatNumber(d.market_cap)}, Price:
                      {currencySymbol}
                      {livePriceData ? (
                        <NumberFormat
                          displayType={"text"}
                          thousandSeparator={true}
                          value={Number(livePriceData[d.id]).toFixed(2)}
                        />
                      ) : (
                        <NumberFormat
                          displayType={"text"}
                          thousandSeparator={true}
                          value={(Number(d.price) / exchangeRate).toFixed(2)}
                        />
                      )}
                      )
                    </span>
                    {index !== 4 && (
                      <span style={{ marginLeft: "20px" }}>|</span>
                    )}
                  </div>
              
              ))
            ) : (
              <></>
            )}
          </Marquee>
          {/* </div> */}
          {/*selection of country's exchange rate
      
        <div className="Header__exchangerates"></div>
      */}
          {headerCoins && headerCoins.length > 0 && (
            <div
              className="Header__selectCurrency"
              onClick={() => setClose(!close)}
            >
              <CurrencyFlag currency={convt} size="sm" /> <span>{convt}</span>
              {close ? <FiChevronDown /> : <FiChevronUp />}
            </div>
          )}
          {close ? (
            <></>
          ) : (
            <div className="Header__setCurrency">
              {currencies.map((c, index) => (
                <div
                  key={index}
                  className="Header__setCurrency__items"
                  onClick={() => {
                    setConvt(c.id);
                    setClose(!close);
                  }}
                >
                  <span>{c.id}</span>
                  <CurrencyFlag currency={c.id} size="sm" />
                  <span>{c.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(Header);
